// Shared constants and utilities for the Admin listing/product forms.
export const gbp = (n) => `£${Number(n).toLocaleString("en-GB", { minimumFractionDigits: 0 })}`;

export const EMPTY_PRODUCT = {
    title: "", designer: "", category: "Outerwear", subcategory: "", size: "", color: "",
    condition: "Excellent", new_with_tags: false, description: "", measurements: "",
    material: "", hardware: "", interior: "", country_of_origin: "", serial_number: "",
    accompanied_by: [],
    price: 0, original_price: null, images: [], edit_slug: "",
    status: "live", authenticated: true, tags: [], sku: "",
};

export const CATEGORIES = ["Outerwear", "Tailoring", "Dresses", "Tops", "Knitwear", "Trousers", "Skirts", "Denim", "Shoes", "Bags", "Accessories", "Jewellery"];
export const CONDITIONS = ["Pristine", "Excellent", "Very Good", "Good"];
export const COLOURS = ["Black", "Ivory", "Cream", "Camel", "Tan", "Chocolate", "Navy", "Grey", "Silver", "Gold", "Red", "Burgundy", "Pink", "Green", "Blue"];
export const HARDWARE = ["Gold", "Silver", "Ruthenium", "Rose Gold", "Antique Brass"];
export const ACCOMPANIED = ["Dust bag", "Box", "Authenticity card", "Receipt", "Serial tag", "Care card", "Spare buckles"];
export const COMMON_SIZES = {
    default: ["XS", "S", "M", "L", "XL"],
    Dresses: ["UK 6", "UK 8", "UK 10", "UK 12", "UK 14", "UK 16"],
    Tops: ["UK 6", "UK 8", "UK 10", "UK 12", "UK 14"],
    Knitwear: ["XS", "S", "M", "L", "XL"],
    Trousers: ["UK 6", "UK 8", "UK 10", "UK 12", "UK 14"],
    Skirts: ["UK 6", "UK 8", "UK 10", "UK 12", "UK 14"],
    Denim: ["24", "25", "26", "27", "28", "29", "30", "31"],
    Shoes: ["35", "36", "37", "38", "39", "40", "41", "42"],
    Bags: ["Mini", "Small", "Medium", "Large", "One Size"],
    Accessories: ["One Size"],
    Jewellery: ["One Size"],
};

export async function compressImage(file, maxW = 1400) {
    return new Promise((resolve) => {
        const r = new FileReader();
        r.onload = () => {
            const img = new Image();
            img.onload = () => {
                const scale = Math.min(1, maxW / img.width);
                const w = Math.round(img.width * scale);
                const h = Math.round(img.height * scale);
                const canvas = document.createElement("canvas");
                canvas.width = w;
                canvas.height = h;
                canvas.getContext("2d").drawImage(img, 0, 0, w, h);
                resolve(canvas.toDataURL("image/jpeg", 0.85));
            };
            img.src = r.result;
        };
        r.readAsDataURL(file);
    });
}
